import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Observable } from 'rxjs';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { UserLexileTest } from 'bookraw/shared/models/user-lexile-test.model';
import { ListResponse } from 'bookraw/shared/models/api/list.response';

@Injectable()
export class UserTestsService extends ListService<UserLexileTest> {

  url: string = '/api/admin/userLexileTests';

  constructor(public http: HttpClient, protected readonly loaderService: AppLoaderService) {
    super(http);
  }

  assignTests(data: { userIds: number[], assignStartsAt: string, assignExpiresAt: string }): Observable<ItemResponse<UserLexileTest>> {
    return this.http.post<ItemResponse<UserLexileTest>>(environment.baseURL + this.url + '/assign', data);
  }

  unAssignTests(data: { userTestIds: number[] }): Observable<ItemResponse<UserLexileTest>> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data };
    return this.http.delete<ItemResponse<UserLexileTest>>(environment.baseURL + this.url + '/destroyMany', options);
  }

  getByUser(userId: string ) {
    return this.http.get<ListResponse<UserLexileTest>>(environment.baseURL + this.url + '/byUser/' + userId);
  }
}
